// src/components/intake/bodies/AboutYouBody.jsx
import React from "react";
import { cn } from "../../ui";
import { ABOUT_YOU_MAX, TextAnswer } from "../IntakeParts";
import { ABOUT_YOU_FIELDS } from "../intakeRules";
import { NO, Q7_PLACEHOLDERS, YES } from "../intakeCopy";

// Q7 (kind `aboutYou`): the Yes/No switch and four answers. The question and
// the four prompts are the seeded options of the page's question (data, not
// copy): option 0 is the switch's question, options 1–4 the prompts, in the
// order of ABOUT_YOU_FIELDS. The switch alone does not answer the page.
export default function AboutYouBody({ page, draft, onChange, idPrefix }) {
  const [question, ...prompts] = page.questions[0].options;
  const on = draft.workedWithAdvisor === true;
  const questionId = `${idPrefix}-advisor-q`;
  return (
    <>
      <div className="tw-mt-6 tw-flex tw-flex-wrap tw-items-center tw-gap-4">
        <span id={questionId} className="tw-text-sm tw-font-semibold">
          {question}
        </span>
        <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-sm">
          <span aria-hidden="true">{NO}</span>
          <button
            type="button"
            role="switch"
            aria-checked={on}
            aria-labelledby={questionId}
            onClick={() => onChange({ ...draft, workedWithAdvisor: !on })}
            className="tw-inline-grid tw-h-11 tw-min-w-11 tw-cursor-pointer tw-place-items-center tw-border-0 tw-bg-transparent tw-p-0 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-focus-ring"
          >
            <span
              aria-hidden="true"
              className={cn(
                "tw-relative tw-block tw-h-7 tw-w-11 tw-rounded-pill tw-transition-colors tw-duration-fast",
                on ? "tw-bg-text-accent" : "tw-bg-border",
              )}
            >
              <span
                className={cn(
                  "tw-absolute tw-left-1 tw-top-1 tw-h-5 tw-w-5 tw-rounded-pill tw-transition-transform tw-duration-fast",
                  on ? "tw-translate-x-4 tw-bg-on-accent" : "tw-bg-surface",
                )}
              />
            </span>
          </button>
          <span aria-hidden="true">{YES}</span>
        </span>
      </div>
      {ABOUT_YOU_FIELDS.map((field, i) => (
        <TextAnswer
          key={field}
          id={`${idPrefix}-${field}`}
          label={`${i + 1}. ${prompts[i]}`}
          placeholder={Q7_PLACEHOLDERS[field]}
          value={draft[field]}
          max={ABOUT_YOU_MAX}
          onChange={(value) => onChange({ ...draft, [field]: value })}
        />
      ))}
    </>
  );
}
